export default {
    LOAD_TUTORIAL(state, tutorial) {
        state.items = tutorial
    }
}